import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import SellerActions from '@Actions/sellerActions';
import TenantActions from '@Actions/tenantActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import ImgCrop from 'antd-img-crop';
import { Upload, Select } from 'antd';
import constants from '@Apis/constants';
import { PlusOutlined } from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import H3ImageSelectorWithCrop from '../../../uilib/H3ImageSelectorWithCrop';
import PRZSelect from '../UI/PRZSelect';

/**
 *
 */
class UpdateTenant extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      sellerName: '',
      gstin: '',
      pinCodeShipping: '',
      districtShipping: '',
      addressShipping: '',
      stateShipping: '',
      phone: '',
      email: '',
      fileList: [],
      toRecipients: [],
      checkedRecipients: true,
      uploadButton: (
        <div>
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>

        </div>
      ),
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {*&{district: *, state: *}}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.tenantsConfiguration && !state.tenantsConfiguration) {
      const { tenantsConfiguration } = props;
      const response = { thumbUrl: tenantsConfiguration?.data?.[0]?.logo_base_64 };
      return {
        ...state,
        fileList: tenantsConfiguration?.data?.[0]?.logo_base_64 ? [response] : [],
        tenantsConfiguration: props.tenantsConfiguration,
      };
    }
    if (props.selectedTenant?.tenant_id !== state.selctedTenatId) {
      return {
        ...state,
        selctedTenatId: props.selectedTenant?.tenant_id,
        tenantName: props.selectedTenant?.tenant_name,
        phone: props.selectedTenant?.mobile,
        email: props.selectedTenant?.email,
        toRecipients: props.selectedTenant?.secondary_email,
        gstin: props.selectedTenant?.gst_number,
        branchCode: props.selectedTenant?.branch_code,
        legalName: props.selectedTenant?.legal_name,
      };
    }

    return state;
  }

  /**
   *
   */
  componentDidMount() {
    const {
      user, getTenantsConfiguration,
    } = this.props;
    if (user?.tenant_info?.org_id) {
      getTenantsConfiguration(user?.tenant_info?.tenant_id);
    }
  }

  /**
   *
   * @param {*} param0
   * @return
   */
  handleChange = ({ fileList }) => this.setState({ fileList });

    /**
     *
     */
    updateTenant = () => {
      this.setState({ formSubmitted: true });
      const {
        tenantName, phone, email, gstin, legalName, fileList, selctedTenatId, branchCode, toRecipients,
      } = this.state;
      const {
        user, callback, updateTenant, updateTenantConfiguration, getTenantsConfiguration, tenantsConfiguration,
      } = this.props;
      if (tenantName && Helpers.validatePhoneNumber(phone) && Helpers.validateEmail(email) && Helpers.validateGstNumber(gstin)) {
        const payload = {
          tenant_id: selctedTenatId,
          tenant_name: tenantName,
          org_id: user?.tenant_info?.org_id,
          description: '',
          email,
          secondary_email: toRecipients,
          mobile: phone,
          is_active: true,
          gst_number: gstin,
          branch_code: branchCode,
          logo: fileList[0]?.thumbUrl,
          legal_name: legalName,
        };
        const updateConfigurationPayload = {
          tenant_id: user?.tenant_info?.tenant_id,
          logo_base_64: fileList[0]?.thumbUrl,
          tenant_configuration_id: tenantsConfiguration?.data?.[0]?.tenant_configuration_id,
        };
        updateTenant(payload, () => {
          updateTenantConfiguration(updateConfigurationPayload,
            () => getTenantsConfiguration(user?.tenant_info?.tenant_id));
          callback();
        });
      }
    }

    /**
     *
     * @return {JSX.Element}
     */
    render() {
      const {
        // getCityState,
        updateTenantLoading,
      } = this.props;
      const {
        tenantName, phone, email, formSubmitted,
        gstin, legalName, fileList, uploadButton, toRecipients, checkedRecipients, branchCode,
      } = this.state;
      return (
        <div className="ant-row">
          <div className="ant-col-md-12">
            <H3FormInput
              name="Tenant Name"
              type="text"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ tenantName: event.target.value })}
              value={tenantName}
              label="Tenant Name"
              maxlength="100"
              required
              disabled={updateTenantLoading}
              showError={formSubmitted && !tenantName}
            />
          </div>
          <div className="ant-col-md-12">
            <H3FormInput
              name="Legal Name"
              type="text"
              containerClassName="orgInputContainer vendor__left-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ legalName: event.target.value })}
              value={legalName}
              label="Legal / Trade Name"
              required
              disabled={updateTenantLoading}
              maxlength="50"
              showError={formSubmitted && !legalName}
            />
          </div>
          <div className="ant-col-md-12">
            <H3FormInput
              name="a valid phone number"
              type="text"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ phone: event.target.value })}
              value={phone}
              label="Phone"
              maxlength="50"
              required
              disabled={updateTenantLoading}
              showError={formSubmitted && !Helpers.validatePhoneNumber(phone)}
            />
          </div>
          <div className="ant-col-md-12">
            <H3FormInput
              name="a valid GST number"
              type="text"
              containerClassName="orgInputContainer vendor__left-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState(
                { gstin: event.target.value, panNumber: event.target.value?.substr(2, 10) },
              )}
              value={gstin}
              required
              disabled={updateTenantLoading}
              showError={formSubmitted && !Helpers.validateGstNumber(gstin)}
              label="GST Number"
            />
          </div>
          <div className="ant-col-md-12">
            <H3FormInput
              name="a valid email"
              type="text"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ email: event.target.value })}
              value={email}
              label="Email"
              maxlength="50"
              required
              disabled={updateTenantLoading}
              showError={formSubmitted && !Helpers.validateEmail(email)}
            />
          </div>
          <div className="ant-col-md-12">
            <div
              className="orgInputContainer vendor__left-input"
              style={{ marginTop: '2px' }}
            >
              <label className="orgFormLabel">
                Secondary Email
              </label>
              <PRZSelect
                mode="tags"
                value={toRecipients}
                filterOption={false}
                maxTagCount="responsive"
                onChange={(value) => {
                  const recipients = [];
                  for (let i = 0; i < value?.length; i++) {
                    if (Helpers.validateEmail(value[i])) {
                      recipients.push(value[i]);
                    }
                  }
                  this.setState({ toRecipients: recipients });
                }}
                disabled={updateTenantLoading}
                style={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '2px',
                  width: '100%',
                  fontSize: '13px',
                  paddingTop: '2px',
                }}
                placeholder=""
                showError={formSubmitted && checkedRecipients && !toRecipients?.length}
                errorName="/ enter at least one recipient"
                errorClassName="formError"
              />
            </div>
          </div>
          <div className="ant-col-md-12">
            <H3FormInput
              name="a branch code"
              type="text"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState(
                { branchCode: event.target.value },
              )}
              value={branchCode}
              required
              disabled={updateTenantLoading}
              showError={formSubmitted && !branchCode}
              label="Branch Code"
            />
          </div>
          <div className="ant-col-md-12" />

          <div className="ant-col-md-12">
            <div className="orgInputContainer  profile__right-input">
              <label className="orgFormLabel">
                Your Logo
              </label>
              <div className="ant-col-md-24">
                        <div className="settings__profile-wrapper-img">

                          <H3ImageSelectorWithCrop>
                            <Upload
                              action={constants.UPLOAD_FILE}
                              listType="picture-card"
                              fileList={fileList}
                              onChange={this.handleChange}
                              showUploadList={{ showPreviewIcon: false }}
                            >
                              {fileList?.length >= 1 ? null
                                : uploadButton}
                            </Upload>
                          </H3ImageSelectorWithCrop>
                        </div>
                      </div>
            </div>
          </div>

          <div className="ant-col-md-12" />
          <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Update Business Unit"
              onClick={() => this.updateTenant()}
              isLoading={updateTenantLoading}
              disabled={updateTenantLoading}
              style={{
                width: '160px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      );
    }
}
const mapStateToProps = ({
  UserReducers, SellerReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  cityStateLoading: SellerReducers.cityStateLoading,
  pincodeCity: SellerReducers.pincodeCity,
  pincodeState: SellerReducers.pincodeState,
  setCityStateError: SellerReducers.setCityStateError,
  updateTenantLoading: TenantReducers.updateTenantLoading,
  tenants: TenantReducers.tenants,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,

});

const mapDispatchToProps = (dispatch) => ({
  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  updateTenant: (payload, callback) => dispatch(TenantActions.updateTenant(payload, callback)),
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getTenantsConfiguration: (tenantId) => dispatch(TenantActions.getTenantsConfiguration(tenantId)),
  updateTenantConfiguration: (payload, callback) => dispatch(TenantActions.updateTenantConfiguration(payload, callback)),

});

UpdateTenant.propTypes = {
  user: PropTypes.any,
  updateTenantLoading: PropTypes.bool,
  selectedTenant: PropTypes.any,
  callback: PropTypes.func,
  updateTenant: PropTypes.func,
  tenantsConfiguration: PropTypes.any,
  getTenantsConfiguration: PropTypes.func,
  updateTenantConfiguration: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateTenant));
